<template>
  <div>
    <a-dropdown style="display: inline-block; height: 100%; vertical-align: initial">
      <span style="cursor: pointer">
        <a-avatar class="avatar" size="small" shape="circle" :src="avatar" :loadError="handleAvatarError"/>
        <span class="curr-user">{{user.username}}</span>
      </span>
      <a-menu style="width: 150px" slot="overlay">
        <a-menu-item @click="openProfile">
          <a-icon type="user"/>
          <span>个人中心</span>
        </a-menu-item>
        <a-menu-item @click="updatePassword">
          <a-icon type="key"/>
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="handleSettingClick">
          <a-icon type="setting"/>
          <span>系统定制</span>
        </a-menu-item>
        <a-menu-divider></a-menu-divider>
        <a-menu-item @click="handleLogoutClick">
          <a-icon type="logout"/>
          <span>退出登录</span>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <a-modal
      title="退出确认"
      :visible="logoutConfirmVisible"
      :confirmLoading="loggingOut"
      okText="确定退出"
      cancelText="取消"
      @ok="logout"
      @cancel="logoutConfirmVisible = false"
    >
      <p>确定要退出当前账号吗？</p>
    </a-modal>
    <update-password
      @success="handleUpdate"
      @cancel="handleCancelUpdate"
      :user="user"
      :updatePasswordModelVisible="updatePasswordModelVisible">
    </update-password>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import UpdatePassword from '../personal/UpdatePassword'

export default {
  name: 'HeaderAvatar',
  components: {UpdatePassword},
  data () {
    return {
      updatePasswordModelVisible: false,
      loggingOut: false,
      avatarFailed: false,
      logoutConfirmVisible: false
    }
  },
  computed: {
    avatar () {
      const avatar = this.avatarFailed ? 'default.jpg' : (this.user.avatar || 'default.jpg')
      return /^(https?:\/\/|\/)/.test(avatar) ? avatar : `static/avatar/${avatar}`
    },
    ...mapState({
      settingBar: state => state.setting.settingBar.opened,
      user: state => state.account.user || {}
    })
  },
  watch: {
    'user.avatar' () { this.avatarFailed = false }
  },
  methods: {
    handleAvatarError () {
      if (this.avatarFailed) return true
      this.avatarFailed = true
      return false
    },
    handleSettingClick () {
      this.setSettingBar(!this.settingBar)
    },
    openProfile () {
      this.$router.push('/profile')
    },
    updatePassword () {
      this.updatePasswordModelVisible = true
    },
    handleCancelUpdate () {
      this.updatePasswordModelVisible = false
    },
    handleUpdate () {
      this.updatePasswordModelVisible = false
      this.$message.success('更新密码成功，请重新登录系统')
      setTimeout(() => {
        this.logout()
      }, 1500)
    },
    handleLogoutClick () {
      if (this.loggingOut) return
      this.logoutConfirmVisible = true
    },
    logout () {
      if (this.loggingOut) return

      this.loggingOut = true

      this.$get('auth/logout', undefined, { hideError: true })
        .then((r) => {
          const result = r.data

          if (
            result === false ||
            (result && result.code !== undefined && Number(result.code) !== 200)
          ) {
            throw new Error((result && result.msg) || '退出系统失败')
          }

          this.$db.clear()
          location.reload()
        })
        .catch(() => {
          this.$message.error('退出系统失败')
          this.logoutConfirmVisible = false
        })
        .finally(() => {
          this.loggingOut = false
        })
    },
    ...mapMutations({setSettingBar: 'setting/setSettingBar'})
  }
}
</script>

<style lang="less" scoped>
  .ant-avatar-sm {
    width: 30px;
    height: 30px;
  }
  .avatar {
    margin: 20px 4px 20px 0;
    color: #1890ff;
    background: hsla(0, 0%, 100%, .85);
    vertical-align: middle;
  }
  .curr-user {
    font-weight: 600;
    margin-left: 6px
  }
</style>
